
  const resumeTypeCodes = {
    Estudiante: 1,
    Escuela: 2,
    Maestro: 3,
  };
  
  export  {resumeTypeCodes};